import React from 'react'
import { createRoot } from 'react-dom/client';
import App from './App'
import { CaptureConsole } from '@sentry/integrations';

import * as Sentry from "@sentry/react";

import { initI18N } from '../../i18next';

/*
Sentry.init({
    dsn: "https://2694f34b93b9951865cfec9bdb1a0a87@o1087374.ingest.sentry.io/4506248647933952",
    integrations: [
        Sentry.browserTracingIntegration(),
        new CaptureConsole({levels: ['error']})
    ],
    environment: 'production',
    tracesSampleRate: .5,
});
*/

initI18N().then(() => {
    const root = createRoot(document.getElementById('checkout-app'));
    root.render(<App />);
});
